export const checkIfBreadKind = (kind: string | undefined | null) =>
  kind === 'bread';
